export default {
    formatarData(data) {
        if (data.indexOf('T') != -1) {
            data = data.substring(0, data.indexOf('T'));
        }

        let arrayData = data.split("-");
        let dia = arrayData[2].length == 2 ? arrayData[2] : `0${arrayData[2]}`;
        let mes = arrayData[1].length == 2 ? arrayData[1] : `0${arrayData[1]}`;
        return `${dia}/${mes}/${arrayData[0]}`;
    },

    formatarDinheiro(valor) {
        return Number.parseFloat(valor).toFixed(2).replace('.', ',').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    formatarCpfCnpj(valor) {
        if (valor === null || valor === undefined) {
            return '';
        }
        const documento = valor.toString().replace(/\D+/g, '');
        if (documento.length <= 11) {
            const parte1 = documento.slice(0, 3);
            const parte2 = documento.slice(3, 6);
            const parte3 = documento.slice(6, 9);
            const parte4 = documento.slice(9, 11);
            return `${parte1}${parte2 ? `.${parte2}` : ''}${parte3 ? `.${parte3}` : ''}${parte4 ? `-${parte4}` : ''}`;
        }
        const cnpj = documento.slice(0, 14);
        const bloco1 = cnpj.slice(0, 2);
        const bloco2 = cnpj.slice(2, 5);
        const bloco3 = cnpj.slice(5, 8);
        const bloco4 = cnpj.slice(8, 12);
        const bloco5 = cnpj.slice(12, 14);
        return `${bloco1}${bloco2 ? `.${bloco2}` : ''}${bloco3 ? `.${bloco3}` : ''}${bloco4 ? `/${bloco4}` : ''}${bloco5 ? `-${bloco5}` : ''}`;
    },

    formatarCpf(cpf) {
        cpf = cpf.toString();
        return `${cpf.substring(0, 3)}.XXX.XXX-${cpf.substring(9)}`;
    }
}